/**
*
*   Cart
*       - A Client Wrapper for the Cart + CurrencySwitcher
*
**/
'use client';

import CartForm from '@/components/cart/form';
import CurrencySwitcher from '@/components/cart/currency-switcher';
import Translation from '@/components/translation';
import { ProductContext } from '@/context/product';
import { Link } from '@/components/link';
import { useContext } from 'react';


//Build the Element
export default function Cart({ product , toggle = true, ...props }){

	const { Product } = useContext(ProductContext);

	//Return
	return (
		<section id="cart">
			{ toggle && (
				<CurrencySwitcher currency={ Product.currency } callback={ ( currency ) => Product.setCurrency( currency ) } />
			)}
			<CartForm type={ Product.currency } product={ product }>
				<Link href={ '/pages/stockists' }>
					<Translation t="Pages.Product.buy-in-store" />
				</Link>
			</CartForm>
		</section>
	);

}